import { useCallback } from "react";
import { api } from "./api-core";
import { ICity } from "./wp-api";

export interface ICountry {
  country_code: string;
  country_name: string;
  created_at: string;
  id: number;
  phonecode: number;
  updated_at: string;
}

export interface IUserProfile {
  id: number;
  username: string;
  password: string;
  roleUser: string;
  avatar_url: string;
  firstname: string;
  lastname: string;
  email: string;
  email_old: string;
  day: string;
  month: string;
  year: string;
  city_id: string;
  city_name: string;
  country_id: string;
  country_name: string;
  listCity: ICity[];
  idUserMD: string;
}

export interface ISchool {
  success: boolean;
  count: number;
  data: {
    id: number;
    province_id: number;
    country_id: number;
    STATE: string;
    SCHOOL_CODE: string;
    SCHOOL_NAME: string;
    ADDRESS: string;
    wp_user_id: string;
    group_id: string;
    is_used: string;
  }[];
}

export interface IRegisterForm{
  firstname: string
  lastname: string
  username: string
  password: string
  confirmPassword?: string
  email: string
  day: string
  month: string
  year: string
  country?: string
  city?: string
  recaptchaToken: any
}

// Hàm hỗ trợ để xử lý các đối tượng lồng nhau và thêm vào FormData
const appendObjectToFormData = (
  formData: FormData,
  data: Record<string, any>,
  parentKey: string = ''
) => {
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      // Tạo khóa mới theo định dạng bp_params[key] hoặc bp_params[parent][key]
      const formattedKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
        // Nếu giá trị là một đối tượng, gọi đệ quy để xử lý các khóa lồng nhau
        appendObjectToFormData(formData, value, formattedKey);
      } else {
        // Nếu giá trị là kiểu dữ liệu cơ bản (chuỗi, số, boolean, null,...)
        // thêm vào FormData với khóa đã được định dạng
        if (value !== null) {
          formData.append(formattedKey, value);
        }
      }
    }
  }
};

var coutryStatic: Promise<ICountry[]>;
export const UserApi = {
  uploadAvatar: (data: { avatar: File, nonce: any, bp_params: Record<string, any>, action: any, name: any }) => {
    const formData = new FormData();
    formData.append("file", data.avatar);
    formData.append("_wpnonce", data.nonce);
    formData.append("action", data.action);
    formData.append("name", data.name);

    if (data.bp_params) {
      appendObjectToFormData(formData, data.bp_params, 'bp_params');
    }

    const url = process.env.API_UPLOAD_AVATAR_USER;
    // const url = '/wp-admin/admin-ajax.php';
    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error in upload avatar:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  getUserWorkspaces: () => {
    const url = process.env.API_GET_USER_WORKSPACE;
    return api.get(url as string).then((res) => res.data.data);
  },
  getUserProfile: () => {
    const url = process.env.API_GET_USER_PROFILE;
    return api.get(url as string).then((res) => res.data);
  },
  getCountryList: (): Promise<ICountry[]> => {
    if (coutryStatic) return coutryStatic;
    coutryStatic = api
      .get(process.env.API_GET_COUNTRY_LIST as string)
      .then((res) => {
        const data = res.data.data || [];
        if (Array.isArray(data) && data.length > 0) {
          return data;
        }
        throw new Error("Country data is empty or invalid");
      })
      .catch((err) => {
        console.error("Error fetching country list:", err);
        return []; // Trả về mảng rỗng khi có lỗi
      });
    return coutryStatic;
  },
  getCityByCountry(id: string): Promise<ICity> {
    const url = `${process.env.API_GET_CITY_LIST}?ID_Country=${id}`;
    return api
      .get(url)
      .then((res) => {
        return res.data.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getSchoolByCity: (page: string, state: string, school_name: string) => {
    const url =
      process.env.API_GET_SCHOOL_BY_CITY +
      `?school_name=${school_name}&page=${page}&state=${state}`;
    return api.get(url as string).then((res) => res.data);
  },
  updateProfile: (data: {
    email: string;
    email_old: string;
    username: string;
    day: string;
    month: string;
    year: string;
    city_id: string;
    country_id: string;
    first_name: string;
    last_name: string;
    idUserMD: string;
  }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường và thêm vào formData
    Object.keys(data).forEach((key) => {
      const k = key as keyof typeof data; // Ép kiểu key là một khóa hợp lệ của đối tượng data
      if (data[k] !== undefined) {
        if (Array.isArray(data[k])) {
          // Nếu là mảng, thêm từng phần tử vào formData
          (data[k] as string[]).forEach((item) => {
            formData.append(`${k}[]`, item);
          });
        } else {
          // Nếu là chuỗi hoặc các kiểu đơn giản khác
          formData.append(k, data[k] as string);
        }
      }
    });

    const url = process.env.URL_UPDATE_PROFILE;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
  registerUSer: (data: IRegisterForm) => {
    const formData = new FormData();
    
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                // Xử lý trường hợp là mảng
                value.forEach((item) => {
                    formData.append(`${key}[]`, item.toString());
                });
            } else if (typeof value === "object" && !Array.isArray(value)) {
                // Xử lý trường hợp là đối tượng (ví dụ: parent)
                Object.entries(value).forEach(([subKey, subValue]) => {
                    if (subValue !== undefined && subValue !== null) {
                        // Sử dụng cú pháp đúng cho FormData
                        formData.append(`${key}[${subKey}]`, subValue.toString());
                    }
                });
            } else {
                // Xử lý các trường đơn
                formData.append(key, value.toString());
            }
        }
    });

    const url = process.env.API_CREATE_EDUCATOR_USER;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
  verifyEmail: (data: { 
    email: string,
    firstname: string,
    lastname: string,
    username: string,
    password: string,
   }) => {
    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("username", data.username);
    formData.append("password", data.password);

    const url = process.env.API_SEND_VERIFY_EMAIL;
    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getNonce: () => {
    const url = `${process.env.API_GET_NONCE}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  updateProfesionalInfo: (data: {
    username?: any,
    first_name?: any,
    last_name?: any,
    email?: any,
    old_email?: any,
    educator_info?: {
      headline?: any,
      country_id?: any,
      is_verified_email?: any,
      verified_organization?: any,
      is_first_access?: any,
    },
    educator_professional?: {
      current_role?: any,
      primary_organization?: any,
      years_of_experience?: any,
      about_me_summary?: any,
    },
    educator_work_experience?: any[],
    educator_professional_links?: any[],
    educator_education?: any[],
    educator_grade_levels?: any[],
    educator_expertise?: any[],
  }) => {
    const formData = new FormData();
    
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                // Xử lý trường hợp là mảng
                  value.forEach((item, index) => {
                    // Kiểm tra nếu phần tử là một đối tượng
                    if (typeof item === "object" && item !== null) {
                        // Duyệt qua các thuộc tính của đối tượng và thêm vào formData
                        Object.entries(item).forEach(([subKey, subValue]) => {
                            if (subValue !== undefined && subValue !== null && subValue !== "") {
                                // Tạo key với cú pháp mảng lồng nhau
                                formData.append(`${key}[${index}][${subKey}]`, subValue.toString());
                            }
                        });
                    } else {
                        // Xử lý trường hợp mảng các giá trị đơn
                        if (item !== undefined && item !== null && item !== "") {
                            formData.append(`${key}[]`, item.toString());
                        }
                    }
                });
            } else if (typeof value === "object" && !Array.isArray(value)) {
                // Xử lý trường hợp là đối tượng (ví dụ: parent)
                Object.entries(value).forEach(([subKey, subValue]) => {
                    if (subValue !== undefined && subValue !== null && subValue !== "") {
                        // Sử dụng cú pháp đúng cho FormData
                        formData.append(`${key}[${subKey}]`, subValue.toString());
                    }
                });
            } else {
                // Xử lý các trường đơn
                formData.append(key, value.toString());
            }
        }
    });
    const url = process.env.API_UPDATE_PROFESIONAL_INFO;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },

  getEducatorInfo: (
    username?: any
  ) => {
    const params = new URLSearchParams();
    if (username) params.append("username", username);

    const url = `${process.env.API_GET_EDUCATOR_INFO}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  sendVerifyEducatorEmail: (data: {
    email?: any,
  }) => {
    const formData = new FormData();
    
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                // Xử lý trường hợp là mảng
                  value.forEach((item, index) => {
                    // Kiểm tra nếu phần tử là một đối tượng
                    if (typeof item === "object" && item !== null) {
                        // Duyệt qua các thuộc tính của đối tượng và thêm vào formData
                        Object.entries(item).forEach(([subKey, subValue]) => {
                            if (subValue !== undefined && subValue !== null && subValue !== "") {
                                // Tạo key với cú pháp mảng lồng nhau
                                formData.append(`${key}[${index}][${subKey}]`, subValue.toString());
                            }
                        });
                    } else {
                        // Xử lý trường hợp mảng các giá trị đơn
                        if (item !== undefined && item !== null && item !== "") {
                            formData.append(`${key}[]`, item.toString());
                        }
                    }
                });
            } else if (typeof value === "object" && !Array.isArray(value)) {
                // Xử lý trường hợp là đối tượng (ví dụ: parent)
                Object.entries(value).forEach(([subKey, subValue]) => {
                    if (subValue !== undefined && subValue !== null && subValue !== "") {
                        // Sử dụng cú pháp đúng cho FormData
                        formData.append(`${key}[${subKey}]`, subValue.toString());
                    }
                });
            } else {
                // Xử lý các trường đơn
                formData.append(key, value.toString());
            }
        }
    });
    const url = process.env.API_SEND_VERIFY_EDU_EMAIL;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
};

export const useApiCache = () => {
  return {
    getCountryList: useCallback(UserApi.getCountryList, []),
  };
};
